import { hydrateDetail } from './hydrate-detail';
import { SkillsPage } from './pages/SkillsPage';
hydrateDetail(<SkillsPage />);
